import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: false,
    error: {
        status: null,
        text: null,
    },
    fetchingIds: [],
    data: {},
};

const serpFeaturesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_SERP_FEATURES_FETCHING: {
            return update(state, {
                fetching: { $set: true },
                fetchingIds: { $set: action?.payload?.keywordsIds || [] },
            });
        }
        case ActionTypes.DATA_SERP_FEATURES_RECEIVED: {
            return update(state, {
                fetching: { $set: false },
                fetchingIds: { $set: [] },
                data: { $merge: action.payload },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SINGLE_SERP_FEATURES_RECEIVED: {
            const newData = {
                ...state.data,
                ...action.payload
            };
            return update(state, {
                data: { $set: newData },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SERP_FEATURES_ERROR: {
            return update(state, {
                data: { $set: initialState.data },
                fetchingIds: { $set: [] },
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    text: { $set: action.payload.text },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default serpFeaturesReducer;
